/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import TextField from "../../../bootstrap/TextField";
import Payment from "../Payment/index.jsx";
import { PaymentHelper } from "../PaymentGateway/PaymentHelper";
import SingleTravellerInformation from "../SingleTravellerInformation";
import {
  InformationHeader,
  TravelarInformation,
} from "./TravellerInformation.styles.js";

const fieldStyle = {
  width: "100%",
  height: 38,
  boxSizing: "border-box",
  padding: "8px 10px",
  border: "1px solid #d1d5db",
  borderRadius: 5,
  fontSize: 13,
};

const labelStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 5,
  color: "#374151",
  fontSize: 12,
  fontWeight: 600,
};

const errorStyle = {
  color: "#dc2626",
  fontSize: 11,
  marginTop: 4,
};

const TravellerInformation = ({
  passengerInformation,
  setPassengerInformation,
  values,
  setValues,
  handleChange,
  discountValue,
  returnAmmount,
  regularAmmount,
  subTripid,
  setLoading,
  token,
  paymentStutas,
}) => {
  const { fareSummery } = useSelector((state) => state.busLists);

  const [step, setStep] = useState(1);
  const [bookingInfo, setBookingInfo] = useState(null);
  const [journeyInfo, setJourneyInfo] = useState({});
  const [searchInfo, setSearchInfo] = useState(null);
  const [returnSearchInfo, setReturnSearchInfo] = useState({});
  const [returnFirstJourneyInfo, setReturnFirstJourneyInfo] = useState({});
  const [journeyInfoTax, setJourneyInfoTax] = useState(null);
  const [bookingInfoTax, setBookingInfoTax] = useState(null);
  const [paymentGateway, setPaymentGateway] = useState("4");
  const [validationErrors, setValidationErrors] = useState({});

  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const read = (key) => {
      try {
        return JSON.parse(localStorage.getItem(key));
      } catch {
        return null;
      }
    };

    setBookingInfo(read("bookingInfo"));
    setJourneyInfo(read("journeyInfo") || {});
    setSearchInfo(read("searchInfo"));
    setReturnSearchInfo(read("returnSearchInfo") || {});
    setReturnFirstJourneyInfo(read("returnFirstJourneyInfo") || {});
    setJourneyInfoTax(read("journeyInfoTax"));
    setBookingInfoTax(read("bookingInfoTax"));
  }, []);

  const seatNumbers = useMemo(() => {
    const rawSeats =
      bookingInfo?.seatnumbers || journeyInfo?.seatnumbers || "";

    if (Array.isArray(rawSeats)) {
      return rawSeats.map(String);
    }

    return String(rawSeats)
      .split(",")
      .map((seat) => seat.trim())
      .filter(Boolean);
  }, [bookingInfo, journeyInfo]);

  const seatCount = Math.max(
    Number(bookingInfo?.totalseat || journeyInfo?.totalseat || 1),
    seatNumbers.length,
    1
  );

  const extraPassengerCount = Math.max(seatCount - 1, 0);

  const contactPhone = String(
    passengerInformation?.login_mobile || ""
  ).trim();

  const contactEmail = String(
    passengerInformation?.login_email || ""
  ).trim();

  const updatePassenger = (name, value) => {
    setPassengerInformation((previous) => ({
      ...previous,
      [name]: value,
    }));

    setValidationErrors((previous) => ({
      ...previous,
      [name]: "",
    }));
  };

  const getAdditionalPassengers = () => {
    return Array.from({ length: extraPassengerCount }, (_, index) => {
      const passengerIndex = index + 2;
      const useContact = values[`useContact${passengerIndex}`] !== false;

      return {
        passenger_number: passengerIndex,
        seat_number: seatNumbers[index + 1] || "",
        first_name: String(values[`first${passengerIndex}`] || "").trim(),
        last_name: String(values[`second${passengerIndex}`] || "").trim(),
        id_number: String(values[`renid${passengerIndex}`] || "").trim(),
        nationality: values[`nationality${passengerIndex}`] || "Kenya",
        phone: useContact
          ? contactPhone
          : String(values[`contactNo${passengerIndex}`] || "").trim(),
        email: useContact
          ? contactEmail
          : String(values[`passengerEmail${passengerIndex}`] || "").trim(),
      };
    });
  };

  const getPassengerList = () => {
    const firstPassenger = {
      passenger_number: 1,
      seat_number: seatNumbers[0] || "",
      first_name: String(passengerInformation?.first_name || "").trim(),
      last_name: String(passengerInformation?.last_name || "").trim(),
      id_number: String(passengerInformation?.id_number || "").trim(),
      nationality: passengerInformation?.country_id || "",
      phone: contactPhone,
      email: contactEmail,
    };

    return [firstPassenger, ...getAdditionalPassengers()];
  };

const isBookingValid = () => {
  // Booking contact phone is required
  if (!contactPhone) return false;

  // Validate email only when supplied
  if (
    contactEmail &&
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactEmail)
  ) {
    return false;
  }

  // First passenger required fields
  if (!String(passengerInformation?.first_name || "").trim()) return false;
  if (!String(passengerInformation?.last_name || "").trim()) return false;
  if (!String(passengerInformation?.id_number || "").trim()) return false;
  if (!String(passengerInformation?.country_id || "").trim()) return false;

  // Additional passengers
  const additionalPassengers = getAdditionalPassengers();

  return additionalPassengers.every((passenger) => {
    const index = passenger.passenger_number;

    if (!passenger.first_name) return false;
    if (!passenger.last_name) return false;
    if (!passenger.id_number) return false;

    if (
      values[`useContact${index}`] === false &&
      !passenger.phone
    ) {
      return false;
    }

    // Validate an additional passenger's email if supplied
    if (
      passenger.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(passenger.email)
    ) {
      return false;
    }

    return true;
  });
};

const canContinueToPayment = isBookingValid();

  const validateBooking = () => {
    const errors = {};

    if (!contactPhone) {
      errors.contactPhone = "Booking contact phone is required.";
    }

    if (
      contactEmail &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactEmail)
    ) {
      errors.contactEmail = "Enter a valid email address.";
    }

    if (!String(passengerInformation?.first_name || "").trim()) {
      errors.first_name = "First name is required.";
    }

    if (!String(passengerInformation?.last_name || "").trim()) {
      errors.last_name = "Last name is required.";
    }

    if (!String(passengerInformation?.id_number || "").trim()) {
      errors.id_number = "ID or passport number is required.";
    }

    if (!String(passengerInformation?.country_id || "").trim()) {
      errors.country_id = "Select a nationality.";
    }

    const additionalPassengers = getAdditionalPassengers();

    additionalPassengers.forEach((passenger) => {
      const index = passenger.passenger_number;

      if (!passenger.first_name) {
        errors[`first${index}`] = `Passenger ${index}: first name is required.`;
      }

      if (!passenger.last_name) {
        errors[`second${index}`] = `Passenger ${index}: last name is required.`;
      }

      if (!passenger.id_number) {
        errors[`renid${index}`] = `Passenger ${index}: ID/passport is required.`;
      }

      if (
        values[`useContact${index}`] === false &&
        !passenger.phone
      ) {
        errors[`contactNo${index}`] = `Passenger ${index}: phone number is required.`;
      }
    });

    setValidationErrors(errors);

    if (Object.keys(errors).length) {
      toast.error("Please complete all required passenger details.");
      return false;
    }

    return true;
  };

  const handleContinueToPayment = () => {
    if (!validateBooking()) return;

    const passengers = getPassengerList();

    // Keep the legacy passenger fields populated for existing integrations.
    const updatedValues = {
      ...values,
      passengers,
    };

    setValues(updatedValues);

    setStep(2);
    window.scrollTo?.({ top: 0, behavior: "smooth" });
  };

  const handleSubmitPayment = async (mpesaPhone) => {
    setLoading?.(true);

    try {
      const passengers = getPassengerList();

      const paymentInformation = {
        totalprice: fareSummery?.grandTotal,
        passengerInformation,
        contactDetails: {
          phone: contactPhone,
          email: contactEmail,
        },
        passengers,
        values: {
          ...values,
          passengers,
        },
        paymentStutas: "Pay Now",
        paymentGateway: 4,
        paymentGatewaySelected: Number(paymentGateway),
        fareSummery,
        searchInfo,
        bookingInfo,
        journeyInfo,
        returnSearchInfo,
        returnFirstJourneyInfo,
        returnAmmount,
        regularAmmount,
        discountValue: discountValue?.discount,
        subTripid,
        journeyInfoTax,
        bookingInfoTax,
        token,
        mpesaPhone,
      };

	const result = await PaymentHelper(
	  paymentInformation,
	  dispatch,
	  history
	);

	console.log("M-PESA payment response:", result);

	return result;
    } catch (error) {
      console.error("M-PESA payment failed:", error);

      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Could not initiate M-PESA payment. Please try again."
      );

      throw error;
    } finally {
      setLoading?.(false);
    }
  };

  const fareTotal = Number(fareSummery?.grandTotal || 0);

  return (
    <TravelarInformation>
      <InformationHeader>
        {step === 1 ? "Passenger information" : "Payment"}
      </InformationHeader>

      {step === 1 ? (
        <>
          <div className="checkout-summary">
            <div>
              <strong>
                {seatCount} {seatCount === 1 ? "passenger" : "passengers"}
              </strong>
              <span>
                {seatNumbers.length
                  ? `Seats: ${seatNumbers.join(", ")}`
                  : "Selected seats"}
              </span>
            </div>
            <strong>KES {fareTotal.toLocaleString("en-KE")}</strong>
          </div>

          <div className="contact-summary">
            <div>
              <strong>Booking contact</strong>
              <span>{contactPhone || "No phone number entered"}</span>
              {contactEmail && <span>{contactEmail}</span>}
            </div>
            <small>Change these details in the contact section above.</small>
          </div>

          <InformationHeader>Passenger 1</InformationHeader>

          {seatNumbers[0] && (
            <p className="seat-caption">Seat {seatNumbers[0]}</p>
          )}

          <div className="passenger-fields-grid">

            <label style={labelStyle}>
              First name <span className="required">*</span>
              <TextField
                name="first_name"
                placeholder="First name"
                value={passengerInformation?.first_name || ""}
                onChange={(event) =>
                  updatePassenger("first_name", event.target.value)
                }
                disabled={Boolean(
                  passengerInformation?.first_name &&
                  token
                )}
              />
              {validationErrors.first_name && (
                <small style={errorStyle}>
                  {validationErrors.first_name}
                </small>
              )}
            </label>

            <label style={labelStyle}>
              Last name <span className="required">*</span>
              <TextField
                name="last_name"
                placeholder="Last name"
                value={passengerInformation?.last_name || ""}
                onChange={(event) =>
                  updatePassenger("last_name", event.target.value)
                }
              />
              {validationErrors.last_name && (
                <small style={errorStyle}>
                  {validationErrors.last_name}
                </small>
              )}
            </label>

            <label style={labelStyle}>
              ID / passport number <span className="required">*</span>
              <TextField
                name="id_number"
                placeholder="Document number"
                value={passengerInformation?.id_number || ""}
                onChange={(event) =>
                  updatePassenger("id_number", event.target.value)
                }
              />
              {validationErrors.id_number && (
                <small style={errorStyle}>
                  {validationErrors.id_number}
                </small>
              )}
            </label>

            <label style={labelStyle}>
              Nationality <span className="required">*</span>
              <select
                value={passengerInformation?.country_id || ""}
                onChange={(event) =>
                  updatePassenger("country_id", event.target.value)
                }
                style={fieldStyle}
              >
                <option value="">Select nationality</option>
                <option value="Kenya">Kenya</option>
                <option value="Uganda">Uganda</option>
                <option value="Tanzania">Tanzania</option>
                <option value="Rwanda">Rwanda</option>
                <option value="South Sudan">South Sudan</option>
                <option value="Other">Other</option>
              </select>
              {validationErrors.country_id && (
                <small style={errorStyle}>
                  {validationErrors.country_id}
                </small>
              )}
            </label>
          </div>

          {Array.from(
            { length: extraPassengerCount },
            (_, index) => {
              const passengerIndex = index + 2;

              return (
                <div className="additional-passenger" key={passengerIndex}>
                  <SingleTravellerInformation
                    passengerIndex={passengerIndex}
                    values={values}
                    handleChange={handleChange}
                    seatNumber={seatNumbers[index + 1]}
                    contactPhone={contactPhone}
                    contactEmail={contactEmail}
                  />

                  {[
                    `first${passengerIndex}`,
                    `second${passengerIndex}`,
                    `renid${passengerIndex}`,
                    `contactNo${passengerIndex}`,
                  ].map(
                    (field) =>
                      validationErrors[field] && (
                        <small key={field} style={errorStyle}>
                          {validationErrors[field]}
                        </small>
                      )
                  )}
                </div>
              );
            }
          )}

		<div className="checkout-actions">
		  <button
			type="button"
			onClick={handleContinueToPayment}
			className="checkout-primary-button"
			disabled={!canContinueToPayment}
		  >
			Continue to payment
			<span aria-hidden="true"> →</span>
		  </button>
		</div>
        </>
      ) : (
        <Payment
          handleSubmitPayment={handleSubmitPayment}
          paymentGateway={paymentGateway}
          setpaymentGateway={setPaymentGateway}
          setLoading={setLoading}
          bookingTotal={fareTotal}
          onBack={() => setStep(1)}
        />
      )}
    </TravelarInformation>
  );
};

export default TravellerInformation;